import { createSlice } from '@reduxjs/toolkit'

// ----------------------------------------------------------------------

export const initialState = {
  contractType: null,
  businessUnitActionContexts: [{}],
  isLoading: false,
  error: ''
}

const slice = createSlice({
  name: 'createPayload',
  initialState,
  reducers: {
    // START LOADING
    startCreatePayloadLoading(state) {
      state.isLoading = true
    },

    // HAS ERROR
    hasCreatePayloadError(state, action) {
      state.isLoading = false
      state.error = action.payload
    },

    // Fetch Create Payload Guarantee
    setGuaranteeRequestPayload(state, action) {
      state.isLoading = false
      state.businessUnitActionContexts = [...action?.payload] || []
      state.contractType = action?.payload[0]?.contractType
    }
  }
})

// Reducer
export default slice.reducer

// ----------------------------------------------------------------------
export const { setGuaranteeRequestPayload, hasCreatePayloadError, startCreatePayloadLoading } =
  slice.actions

export function getCreatePayload(data: Response, status, dispatch) {
  dispatch(slice.actions.startCreatePayloadLoading())
  try {
    if (status.status === 'OK') {
      dispatch(slice.actions.setGuaranteeRequestPayload(data))
    } else {
      dispatch(slice.actions.hasCreatePayloadError('Error Occurred while fetching create Payload'))
    }
  } catch (error) {
    dispatch(slice.actions.hasCreatePayloadError(error))
  }
}
